import { useState } from "react";
import { useParams } from "react-router-dom";
import { EndPoints } from "../../../../Constants/endpoints";
import { PrescriptionType } from "../../../../interface/GeneralResponse";
import { useTranslation } from "react-i18next";
import { PrescriptionCard } from "../component";
import { InfiniteScroll, TitleWithArrowLink } from "../../../../components";
import { CardWithIconSkeleton } from "../../../../Share";
import EmptyIcon from "../../../../assets/images/icons/empty-prescription.svg";

function PrescriptionsByDoctors({ className }: { className?: string }) {
  const { id } = useParams();
  const [prescriptionData, setPrescriptionData] =
    useState<PrescriptionType[]>();

  const { t } = useTranslation();
  return (
    <div
      className={`h-full ${className ? className : "max-h-[65vh]"} overflow-auto`}
    >
      {className ? (
        <TitleWithArrowLink title="prescriptions_by_doctors" />
      ) : (
        <h1 className="mb-2 text-sm font-semibold">
          {t("prescriptions_by_doctors")}
        </h1>
      )}

      <div className="grid grid-cols-1 gap-3">
        {(prescriptionData?.length ?? 0) > 0 &&
          prescriptionData?.map((e) => (
            <PrescriptionCard key={e.Id} item={e} />
          ))}
        <InfiniteScroll
          Count={20}
          skeletonCount={20}
          endpoint={`${EndPoints.getPrescriptionGroupByDoctors}`}
          getAllParams={{ PatientId: id }}
          getData={(data) => setPrescriptionData(data)}
          renderSkeleton={<CardWithIconSkeleton />}
          noDataElement={
            <div className="flex h-[34vh] flex-col items-center justify-center gap-4 lg:w-[36%]">
              <img
                alt="empty"
                className="max-w-32 opacity-70"
                src={EmptyIcon}
              />
              <h4 className="text-center text-body-text">{t("no_data_yet")}</h4>
            </div>
          }
        />
      </div>
    </div>
  );
}

export default PrescriptionsByDoctors;
